import PaymentsIcon from './PaymentsIcon';

export default PaymentsIcon;
